@if (data.data != undefined) {
  <ul class="list-group drag_filter_ul">
    @for (item of data.data; track item; let k = $index) {
      <li class="dropzone list-group-item {{item.userGroupId != undefined?'no_drag':''}}" id='{{k}}' draggable="true">
        {{item.name}}
        <a href="javascript:void(0)" class="pull-right" (click)="removeFilter(item,k)"><i aria-hidden="true"
        class="fa fa-trash"></i></a>
      </li>
    }
  </ul>
}